/**
 * If enabled, display retrieval and ranking debug info in product tiles
 * Product Area: RANKING
 */
export const SHOULD_DISPLAY_RETRIEVAL_AND_RANKING_DEBUG_INFO = 'SHOULD_DISPLAY_RETRIEVAL_AND_RANKING_DEBUG_INFO';
